export interface Filter {
    fieldName: string;
    value: string;
    displayText: string;
}
